import { render, staticRenderFns } from "./SectionAboutSlogan.vue?vue&type=template&id=095a3907&scoped=true&"
import script from "./SectionAboutSlogan.vue?vue&type=script&lang=js&"
export * from "./SectionAboutSlogan.vue?vue&type=script&lang=js&"
import style0 from "./SectionAboutSlogan.vue?vue&type=style&index=0&id=095a3907&lang=scss&scoped=true&"
import style1 from "./SectionAboutSlogan.vue?vue&type=style&index=1&id=095a3907&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095a3907",
  null
  
)

export default component.exports